/**
 * @class DateUtils
 * @example
 * const formattedDate = DateUtils.toLocaleDateString("2026-02-01 08:00:00");
 * console.log(formattedDate); // "02/01/2026"
 */
class DateUtils {
  /**
   * 
   * @param {string} dateString - The date in 'YYYY-MM-DD hh:mm:ss' format
   * @returns {string} - The converted date into the localStorage stored locale or "pt-BR" as default
   */
  static toLocaleDateString(dateString) {
    const locale = localStorage.getItem("i18nextLng") ?? "pt-BR";
    return new Date(dateString).toLocaleDateString(locale);
  }
}

export default DateUtils;
